import {
  useRouteError,
  isRouteErrorResponse,
  useNavigate,
} from "react-router-dom";
import { ErrorUI } from "./shared/error-ui";
import { captureException } from "@sentry/react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export function ErrorBoundary() {
  const error = useRouteError();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (error) {
      captureException(error, {
        tags: {
          errorType: isRouteErrorResponse(error)
            ? "RouteError"
            : "UnhandledError",
          // Add any other relevant tags
        },
      });
    }
  }, [error]);

  const getErrorDetails = () => {
    if (isRouteErrorResponse(error)) {
      return {
        title: `${error.status} ${error.statusText}`,
        description:
          error.status === 404
            ? t("errorUi.notFoundWithOrderId")
            : t("errorUi.requestFailed"),
      };
    }

    if (error instanceof Error) {
      return {
        title: t("errorUi.genericTitle"),
        description: error.message,
        error,
      };
    }

    return {
      title: t("errorUi.genericTitle"),
      description: t("errorUi.genericBody"),
    };
  };

  const { title, description, error: errorObj } = getErrorDetails();

  return (
    <ErrorUI
      title={title}
      description={description}
      error={errorObj}
      showStackTrace={true}
      onBack={() => navigate(-1)}
    />
  );
}
